var _a, _b, _c, _d, _e;
// Main chart types (for future expansion to bar, area, pie charts)
export var ChartType;
(function (ChartType) {
    ChartType["LINE"] = "line";
    ChartType["BAR"] = "bar";
    ChartType["AREA"] = "area";
    ChartType["PIE"] = "pie";
    ChartType["RADAR"] = "radar";
    ChartType["RADIAL"] = "radial";
})(ChartType || (ChartType = {}));
// Line chart specific variants
export var LineChartVariant;
(function (LineChartVariant) {
    LineChartVariant["DEFAULT"] = "default";
    LineChartVariant["LINEAR"] = "linear";
    LineChartVariant["STEP"] = "step";
    LineChartVariant["MULTIPLE"] = "multiple";
    LineChartVariant["DOTS"] = "dots";
    LineChartVariant["DOTS_CUSTOM"] = "dots-custom";
    LineChartVariant["DOTS_COLORS"] = "dots-colors";
    LineChartVariant["LABEL"] = "label";
    LineChartVariant["LABEL_CUSTOM"] = "label-custom";
})(LineChartVariant || (LineChartVariant = {}));
// Bar chart variants (based on shadcn/ui examples)
export var BarChartVariant;
(function (BarChartVariant) {
    BarChartVariant["DEFAULT"] = "default";
    BarChartVariant["INTERACTIVE"] = "interactive";
    BarChartVariant["HORIZONTAL"] = "horizontal";
    BarChartVariant["MULTIPLE"] = "multiple";
    BarChartVariant["STACKED"] = "stacked";
    BarChartVariant["STACKED_LEGEND"] = "stacked-legend";
    BarChartVariant["LABEL"] = "label";
    BarChartVariant["LABEL_CUSTOM"] = "label-custom";
    BarChartVariant["MIXED"] = "mixed";
    BarChartVariant["ACTIVE"] = "active";
    BarChartVariant["NEGATIVE"] = "negative";
})(BarChartVariant || (BarChartVariant = {}));
// Area chart variants (based on shadcn/ui examples)
export var AreaChartVariant;
(function (AreaChartVariant) {
    AreaChartVariant["DEFAULT"] = "default";
    AreaChartVariant["INTERACTIVE"] = "interactive";
    AreaChartVariant["LINEAR"] = "linear";
    AreaChartVariant["STEP"] = "step";
    AreaChartVariant["LEGEND"] = "legend";
    AreaChartVariant["STACKED"] = "stacked";
    AreaChartVariant["STACKED_EXPANDED"] = "stacked-expanded";
    AreaChartVariant["ICONS"] = "icons";
    AreaChartVariant["GRADIENT"] = "gradient";
    AreaChartVariant["AXES"] = "axes";
})(AreaChartVariant || (AreaChartVariant = {}));
export var PieChartVariant;
(function (PieChartVariant) {
    PieChartVariant["DEFAULT"] = "default";
    PieChartVariant["SEPARATOR_NONE"] = "separator-none";
    PieChartVariant["LABEL"] = "label";
    PieChartVariant["CUSTOM_LABEL"] = "custom-label";
    PieChartVariant["LABEL_LIST"] = "label-list";
    PieChartVariant["LEGEND"] = "legend";
    PieChartVariant["DONUT"] = "donut";
    PieChartVariant["DONUT_ACTIVE"] = "donut-active";
    PieChartVariant["DONUT_WITH_TEXT"] = "donut-with-text";
    PieChartVariant["STACKED"] = "stacked";
    PieChartVariant["INTERACTIVE"] = "interactive";
})(PieChartVariant || (PieChartVariant = {}));
// Default chart colors
export var DEFAULT_CHART_COLORS = [
    "var(--chart-1)",
    "var(--chart-2)",
    "var(--chart-3)",
    "var(--chart-4)",
    "var(--chart-5)"
];
// Chart type display names
export var CHART_TYPE_NAMES = (_a = {},
    _a[ChartType.LINE] = "Line Chart",
    _a[ChartType.BAR] = "Bar Chart",
    _a[ChartType.AREA] = "Area Chart",
    _a[ChartType.PIE] = "Pie Chart",
    _a[ChartType.RADAR] = "Radar Chart",
    _a[ChartType.RADIAL] = "Radial Chart",
    _a);
// Line chart variant configurations
export var LINE_CHART_VARIANT_CONFIGS = (_b = {},
    _b[LineChartVariant.DEFAULT] = {
        lineType: "natural",
        showDots: false,
        showLabels: false,
        strokeWidth: 2
    },
    _b[LineChartVariant.LINEAR] = {
        lineType: "linear",
        showDots: false,
        showLabels: false,
        strokeWidth: 2
    },
    _b[LineChartVariant.STEP] = {
        lineType: "step",
        showDots: false,
        showLabels: false,
        strokeWidth: 2
    },
    _b[LineChartVariant.MULTIPLE] = {
        lineType: "monotone",
        showDots: false,
        showLabels: false,
        strokeWidth: 2
    },
    _b[LineChartVariant.DOTS] = {
        lineType: "natural",
        showDots: true,
        showLabels: false,
        strokeWidth: 2
    },
    _b[LineChartVariant.DOTS_CUSTOM] = {
        lineType: "natural",
        showDots: true,
        showLabels: false,
        strokeWidth: 2,
        customDots: true
    },
    _b[LineChartVariant.DOTS_COLORS] = {
        lineType: "natural",
        showDots: true,
        showLabels: false,
        strokeWidth: 2,
        coloredDots: true
    },
    _b[LineChartVariant.LABEL] = {
        lineType: "natural",
        showDots: true,
        showLabels: true,
        strokeWidth: 2
    },
    _b[LineChartVariant.LABEL_CUSTOM] = {
        lineType: "natural",
        showDots: true,
        showLabels: true,
        strokeWidth: 2,
        customLabels: true
    },
    _b);
// Bar chart variant configurations
export var BAR_CHART_VARIANT_CONFIGS = (_c = {},
    _c[BarChartVariant.DEFAULT] = {
        layout: "vertical",
        showGrid: true,
        showLegend: false,
        stacked: false,
        interactive: false
    },
    _c[BarChartVariant.INTERACTIVE] = {
        layout: "vertical",
        showGrid: true,
        showLegend: false,
        stacked: false,
        interactive: true
    },
    _c[BarChartVariant.HORIZONTAL] = {
        layout: "horizontal",
        showGrid: true,
        showLegend: false,
        stacked: false,
        interactive: false
    },
    _c[BarChartVariant.MULTIPLE] = {
        layout: "vertical",
        showGrid: true,
        showLegend: true,
        stacked: false,
        interactive: false
    },
    _c[BarChartVariant.STACKED] = {
        layout: "vertical",
        showGrid: true,
        showLegend: false,
        stacked: true,
        interactive: false
    },
    _c[BarChartVariant.STACKED_LEGEND] = {
        layout: "vertical",
        showGrid: true,
        showLegend: true,
        stacked: true,
        interactive: false
    },
    _c[BarChartVariant.LABEL] = {
        layout: "vertical",
        showGrid: true,
        showLegend: false,
        stacked: false,
        showLabels: true,
        interactive: false
    },
    _c[BarChartVariant.LABEL_CUSTOM] = {
        layout: "vertical",
        showGrid: true,
        showLegend: false,
        stacked: false,
        showLabels: true,
        customLabels: true,
        interactive: false
    },
    _c[BarChartVariant.MIXED] = {
        layout: "vertical",
        showGrid: true,
        showLegend: true,
        stacked: false,
        mixed: true,
        interactive: false
    },
    _c[BarChartVariant.ACTIVE] = {
        layout: "vertical",
        showGrid: true,
        showLegend: false,
        stacked: false,
        activeIndex: 0,
        interactive: true
    },
    _c[BarChartVariant.NEGATIVE] = {
        layout: "vertical",
        showGrid: true,
        showLegend: true,
        stacked: false,
        allowNegative: true,
        interactive: false
    },
    _c);
// Area chart variant configurations
export var AREA_CHART_VARIANT_CONFIGS = (_d = {},
    _d[AreaChartVariant.DEFAULT] = {
        curveType: "natural",
        showGrid: true,
        showLegend: false,
        stacked: false,
        fillOpacity: 0.4
    },
    _d[AreaChartVariant.INTERACTIVE] = {
        curveType: "natural",
        showGrid: true,
        showLegend: false,
        stacked: false,
        fillOpacity: 0.4,
        interactive: true
    },
    _d[AreaChartVariant.LINEAR] = {
        curveType: "linear",
        showGrid: true,
        showLegend: false,
        stacked: false,
        fillOpacity: 0.4
    },
    _d[AreaChartVariant.STEP] = {
        curveType: "step",
        showGrid: true,
        showLegend: false,
        stacked: false,
        fillOpacity: 0.4
    },
    _d[AreaChartVariant.LEGEND] = {
        curveType: "natural",
        showGrid: true,
        showLegend: true,
        stacked: false,
        fillOpacity: 0.4
    },
    _d[AreaChartVariant.STACKED] = {
        curveType: "natural",
        showGrid: true,
        showLegend: true,
        stacked: true,
        fillOpacity: 0.4
    },
    _d[AreaChartVariant.STACKED_EXPANDED] = {
        curveType: "natural",
        showGrid: true,
        showLegend: true,
        stacked: true,
        stackOffset: "expand",
        fillOpacity: 0.4
    },
    _d[AreaChartVariant.ICONS] = {
        curveType: "natural",
        showGrid: true,
        showLegend: true,
        stacked: false,
        fillOpacity: 0.4,
        showIcons: true
    },
    _d[AreaChartVariant.GRADIENT] = {
        curveType: "natural",
        showGrid: true,
        showLegend: false,
        stacked: false,
        fillOpacity: 1,
        gradient: true
    },
    _d[AreaChartVariant.AXES] = {
        curveType: "natural",
        showGrid: true,
        showLegend: false,
        stacked: false,
        fillOpacity: 0.4,
        showAxes: true
    },
    _d);
export var PIE_CHART_VARIANT_CONFIGS = (_e = {},
    _e[PieChartVariant.DEFAULT] = {
        innerRadius: 0,
        showLabels: false,
        showLegend: false
    },
    _e[PieChartVariant.SEPARATOR_NONE] = {
        innerRadius: 0,
        showLabels: false,
        showLegend: false,
        separatorStroke: 0
    },
    _e[PieChartVariant.LABEL] = {
        innerRadius: 0,
        showLabels: true,
        showLegend: false
    },
    _e[PieChartVariant.CUSTOM_LABEL] = {
        innerRadius: 0,
        showLabels: false,
        showLegend: false,
        customLabel: true
    },
    _e[PieChartVariant.LABEL_LIST] = {
        innerRadius: 0,
        showLabels: false,
        showLegend: false,
        labelList: true
    },
    _e[PieChartVariant.LEGEND] = {
        innerRadius: 0,
        showLabels: false,
        showLegend: true
    },
    _e[PieChartVariant.DONUT] = {
        innerRadius: 60,
        showLabels: false,
        showLegend: false
    },
    _e[PieChartVariant.DONUT_ACTIVE] = {
        innerRadius: 60,
        showLabels: false,
        showLegend: false,
        strokeWidth: 5,
        activeIndex: 0
    },
    _e[PieChartVariant.DONUT_WITH_TEXT] = {
        innerRadius: 60,
        showLabels: false,
        showLegend: false,
        strokeWidth: 5,
        withText: true
    },
    _e[PieChartVariant.STACKED] = {
        innerRadius: 60,
        showLabels: false,
        showLegend: false,
        stacked: true
    },
    _e[PieChartVariant.INTERACTIVE] = {
        innerRadius: 60,
        showLabels: false,
        showLegend: false,
        strokeWidth: 5,
        interactive: true
    },
    _e);
// Utility functions for chart type operations
export var getChartDisplayName = function (type, variant) {
    var typeName = CHART_TYPE_NAMES[type];
    if (variant === LineChartVariant.DEFAULT) {
        return typeName;
    }
    return "".concat(typeName, " - ").concat(variant.split('-').map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' '));
};
export var createChartConfiguration = function (type, variant, data, config, title, description, metadata) { return ({
    type: type,
    variant: variant,
    title: title,
    description: description,
    data: data,
    config: config,
    metadata: metadata
}); };
export var createChartInstance = function (type, variant, configuration) { return ({
    id: "chart-".concat(type, "-").concat(variant, "-").concat(Date.now()),
    type: type,
    variant: variant,
    configuration: configuration,
    createdAt: new Date()
}); };
